import React from 'react'
import { useSelector } from 'react-redux';
import { getParticipants } from "./../../features/base/participants"
import Video from "./../../features/base/media/components/Video";
import Avatar from "../../features/base/avatar/components/Avatar";
import { getTrackByMediaTypeAndParticipant } from '../../features/base/tracks';
import { MEDIA_TYPE } from '../../features/base/media';

function SmallSection() {
    const { _largeVideoID, _allParticipants, _tracks } = useSelector(state => {
        const _largeVideoID = state["features/large-video"].participantId;
        const _allParticipants = getParticipants(state);
        const _tracks = state["features/base/tracks"];
        return {
            _largeVideoID, _allParticipants, _tracks
        }
    })

    const getTrack = (type, id,) => {
        let val;
        if (type === "video") {
            val = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.VIDEO, id);
        } else {
            val = getTrackByMediaTypeAndParticipant(_tracks, MEDIA_TYPE.AUDIO, id);
        }
        return val;
    }
    return (
        <div
            id='remoteVideos'>
            <div className='filmstrip__videos' id='filmstripLocalVideo'>
                <div id='filmstripLocalVideoThumbnail' >
                    {_allParticipants instanceof Array ? _allParticipants.map((_value) => {
                        if (_value.id === _largeVideoID) return;
                        let _trackStatus = getTrack("video", _value?.id);
                        // let _trackStatusAudio = getTrack("audio", _value?.id);
                        return (
                            <>
                                {_trackStatus?.muted || _trackStatus?.muted === undefined || _trackStatus === undefined ? (
                                    <Avatar participantId={_value?.id} size={150} />
                                ) : (
                                    <Video
                                        className={`video-input-preview-display`}
                                        videoTrack={{ jitsiTrack: _trackStatus?.jitsiTrack }}
                                        style={{ transform: "scaleX(-1)" }}
                                    />
                                )}
                            </>
                        )
                    }) : null}
                </div>
            </div>
        </div>
    )
}

export default SmallSection